(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("RangePricesApi", [
    "$q",
    "$filter",
    "API",
    "DebugLogger",
    function ($q, $filter, API, DebugLogger) {
      function getByMaterialCodes(materialCodeObj, postcode, usageType) {
        var materialCodeObjSerialised = materialCodeObj
          .map(function (el) {
            return el.materialCode;
          })
          .join("|");

        return API.get(
          $filter("formatArgs")(ToyotaConsts.API.Vehicle.PriceByMaterialCodes, [
            materialCodeObjSerialised,
            postcode,
            usageType,
          ])
        ).then(function (response) {
          if (!response.data.success) {
            DebugLogger.log("RangePricesApi", "getMyMaterialCodes: server responded with falsy success");
            throw new Error("RangePricesApi.getMyMaterialCodes: server responded with falsy success");
          }

          return response.data;
        });
      }

      return {
        getByMaterialCodes: getByMaterialCodes,
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
